import { SimpleGrid } from '@chakra-ui/react'
import { ClipboardList, Hourglass, FileText, FileCheck } from 'lucide-react'
import { StatCard } from './StatCard'

type RequestorStatsRowProps = {
  totalRequests?: number
  inProgress?: number
  openRequests?: number
  resolvedRequests?: number
}

export function RequestorStatsRow({
  totalRequests = 0,
  inProgress = 0,
  openRequests = 0,
  resolvedRequests = 0,
}: RequestorStatsRowProps) {
  return (
    <SimpleGrid
      templateColumns={{
        base: '1fr',
        sm: 'repeat(2, 1fr)',
        lg: 'repeat(4, 1fr)',
      }}
      gap={{ base: 4, md: 6 }}
      w="100%"
      minW={0}
    >
      <StatCard
        title="Total Requests"
        value={Number(totalRequests)}
        icon={ClipboardList}
        color="gray"
      />
      <StatCard
        title="In Progress"
        value={Number(inProgress)}
        icon={Hourglass}
        color="yellow"
      />
      <StatCard
        title="Open Requests"
        value={Number(openRequests)}
        icon={FileText}
        color="blue"
      />
      <StatCard
        title="Resolved Requests"
        value={Number(resolvedRequests)}
        icon={FileCheck}
        color="green"
      />
    </SimpleGrid>
  )
}

export default RequestorStatsRow
